// Meta Pixel helpers pentru SPA (React Router)
export const fbTrack = (event, params) => {
  if (typeof window !== "undefined" && typeof window.fbq === "function") {
    window.fbq("track", event, params || {});
  }
};

export const fbPageView = () => fbTrack("PageView");
